<template lang='pug'>
  i.svg-icon.svg-icon-donate
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      circle(fill='#F7CB65' cx='40.42' cy='52.82' r='35.219')
      path(fill='#F6BD52' d='M40.42,17.601c-1.542,0-3.062,0.099-4.552,0.292c17.301,2.233,30.668,17.019,30.668,34.928 c0,17.908-13.367,32.694-30.668,34.926c1.49,0.192,3.01,0.293,4.552,0.293c19.45,0,35.218-15.767,35.218-35.219 C75.638,33.369,59.87,17.601,40.42,17.601L40.42,17.601z')
      path(fill='#CF955B' d='M62.844,7.079c-4.879-0.156-9.605,1.714-13.056,5.168l-5.681,5.688c2.816,0.012,5.491,0.62,7.903,1.707 l5.832-3.144c1.161-0.626,2.563-0.602,3.704,0.063l3.456,2.016c2.383,1.391,2.527,4.781,0.271,6.368l-10.548,7.765 c-1.409,0.991-1.868,2.911-0.979,4.386c0.807,1.343,2.445,1.914,3.903,1.385l7.056-2.255c2.887-0.923,5.536-2.47,7.762-4.528 l7.753-7.172c0.543-0.502,1.254-0.781,1.992-0.781h2.464V7.843L62.844,7.079z')
      path(fill='#BE8658' d='M81.511,23.83c0.229-0.056,0.464-0.088,0.702-0.088h2.464V7.843l-3.166-0.111V23.83z')
      path(fill='#365C7A' d='M95.114,28.129h-9.349c-0.602,0-1.089-0.487-1.089-1.087V6.049c0-0.601,0.487-1.087,1.089-1.087h9.349 c0.601,0,1.089,0.487,1.089,1.087v20.993C96.203,27.643,95.715,28.129,95.114,28.129z')
      path(fill='#2B4C64' d='M95.114,4.961h-3.003c0.6,0,1.087,0.487,1.087,1.087v20.993c0,0.601-0.487,1.087-1.087,1.087h3.003 c0.601,0,1.089-0.487,1.089-1.087V6.049C96.203,5.448,95.715,4.961,95.114,4.961z')
      path(fill='#DFA133' d='M38.859,74.06c-4.315,0-6.96-0.354-11.285-2.868c-1.277-0.742-1.634-2.264-0.8-3.4 c0.834-1.134,2.546-1.449,3.822-0.709c3.325,1.934,4.87,2.09,8.774,2.064c4.687-0.026,7.406-3.134,7.949-6.009 c0.218-1.152,0.532-5.035-4.57-6.639c-5.966-1.877-9.395-3.336-11.833-5.037c-2.73-1.903-3.972-5.227-3.241-8.672 c0.801-3.781,3.752-6.786,7.702-7.844c7.993-2.14,13.723,1.332,13.962,1.48c1.251,0.775,1.559,2.307,0.686,3.418 c-0.868,1.107-2.576,1.381-3.825,0.621c-0.197-0.117-3.911-2.244-9.23-0.818c-2.353,0.631-3.54,2.506-3.868,4.051 c-0.348,1.639,0.121,3.134,1.223,3.902c2.397,1.671,6.535,3.096,10.266,4.267c5.998,1.886,9.206,6.629,8.175,12.084 c-0.913,4.834-5.484,10.059-13.358,10.106C39.223,74.06,39.04,74.06,38.859,74.06L38.859,74.06z')
      path(fill='#DFA133' d='M39.39,79.123c-1.525,0-2.761-1.1-2.761-2.455V32.1c0-1.355,1.236-2.455,2.761-2.455 s2.762,1.099,2.762,2.455v44.568C42.151,78.023,40.916,79.123,39.39,79.123z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}

</script>
